// Reloj para cuentas regresivas que se MUESTRAN (#1809: "Quedan 14 h 29 min para el corte",
// la franja de «Estoy de turno»). Re-renderiza cada `cadaMs` mientras `activo`. Nunca decide un
// vencimiento: eso lo hace el backend comparando instantes (rules/frontend.md).
import { useEffect, useState } from "react";

const useAhora = (activo = true, cadaMs = 30000) => {
  const [ahora, setAhora] = useState(() => Date.now());
  useEffect(() => {
    if (!activo) return undefined;
    setAhora(Date.now());
    const id = setInterval(() => setAhora(Date.now()), cadaMs);
    return () => clearInterval(id);
  }, [activo, cadaMs]);
  return ahora;
};

export default useAhora;
